export default function Introduction() {
  return (
    <section className="py-24 md:py-40 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        {/* Headline - モバイルで縮小、洗練された印象に */}
        <p className="text-xl md:text-3xl lg:text-4xl font-medium text-gray-900 leading-relaxed mb-8 md:mb-12">
          踊れなくても、<br />
          ダンス未経験でも大丈夫。
        </p>
        
        <div className="h-px w-16 md:w-24 bg-gray-300 mx-auto my-10 md:my-16"></div>
        
        {/* Body Text - レスポンシブな改行で最適化 */}
        <div className="max-w-xs md:max-w-2xl mx-auto">
          <p className="text-sm md:text-xl font-light text-gray-700 leading-[1.8] md:leading-relaxed">
            リズムスクワットやトレーニングから始まり、<br />
            自然に『表現するダンス』へ<br className="md:hidden" />
            導くプログラムです。
          </p>
        </div>
      </div>
    </section>
  );
}